/**
 * UploadModuleModal component constants
 * @returns {Variables}
 */

export const UNIVERSAL_FILE_NAME = 'Universal';
